import React from "react";
import { Typography, Card, Row, Col } from "antd";
import { FormOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

const { Title, Paragraph } = Typography;

const OverviewPage: React.FC = () => {
  return (
    <div>
      <Title level={2}>Welcome to the Meed Internal Portal</Title>
      <Paragraph type="secondary">
        This is your central hub for managing internal tools and systems. Select
        an option from the sidebar to get started.
      </Paragraph>
      <Row gutter={16}>
        <Col span={8}>
          <Link to="/wizards">
            <Card hoverable>
              <Card.Meta
                avatar={<FormOutlined style={{ fontSize: "24px" }} />}
                title="Wizard CMS"
                description="Create, edit, and manage merchant onboarding wizards."
              />
            </Card>
          </Link>
        </Col>
      </Row>
    </div>
  );
};

export default OverviewPage;
